<template>
  <div class="apply">

    <div class="apply-top">
      <van-nav-bar title="职位申请">
        <template #right>
          <van-icon name="user-circle-o" size="24" @click="toHomePage"/>
        </template>
      </van-nav-bar>
      <van-dropdown-menu>
        <van-dropdown-item title="工作地点" v-model="city" :options="cityOption" @change="handleSearch(city, typeId, keyword)" />
        <van-dropdown-item title="工作职能" v-model="typeId" :options="typeOption" @change="handleSearch(city, typeId, keyword)" />
      </van-dropdown-menu>
      <van-search clearable placeholder="请输入关键词"
                  v-model="keyword" @search="handleSearch(city, typeId, keyword)" />
    </div>

    <div class="apply-body" ref="root">
      <van-skeleton :loading="loading" :row="3" :style="{ paddingTop: '16px' }">
        <van-empty v-if="dataList.length < 1" description="暂无岗位数据" />
        <van-cell-group v-if="dataList.length > 0">
          <van-swipe-cell v-for="data in dataList" :key="data">
            <van-cell :key="data"
                      :title="data['title']"
                      :value="data['city']"
                      @click="showJob(data)">
              <template #value>
                <van-row justify="end">
                  <van-tag plain type="primary" size="medium">{{ data['type'] }}</van-tag>
                </van-row>
              </template>
              <template #label>
                <van-row>
                  <span>{{ data['city'] }} · {{ data['company'] }}</span>
                </van-row>
                <van-row>
                  <van-tag plain type="primary" size="medium">{{ data['education'] }}</van-tag>
                </van-row>
              </template>
            </van-cell>
            <!--            <template #right>-->
            <!--              <van-button style="height: 100%" square type="danger" icon="delete-o" text="删除"-->
            <!--                          @click="deleteRecord(data)"-->
            <!--                          v-if="experiment.state === '1'"/>-->
            <!--            </template>-->
          </van-swipe-cell>
        </van-cell-group>
      </van-skeleton>
    </div>

  </div>
</template>

<script>
import {getCityOption, getJobList, getTypeOption} from "@/api";
import {showNotify} from "vant";
import {onActivated, ref} from "vue";
import {useEventListener, useScrollParent} from "@vant/use";
import {onBeforeRouteLeave} from "vue-router";

export default {
  name: "JobList",
  data() {
    return {
      loading: true,
      dataList: [],
      city: '',
      typeId: 0,
      keyword: '',
      cityOption: [],
      typeOption: [
        { text: '全部类型', value: 0 },
      ],
    }
  },
  setup() {
    const root = ref();
    const scrollParent = useScrollParent(root);
    const savedScrollTop = ref(0);

    useEventListener(
        'scroll',
        () => {
          // console.log("scrollParent.scrollTop: "+scrollParent.value.scrollTop);
        },
        { target: scrollParent },
    );

    // 组件激活时恢复滚动位置
    onActivated(() => {
      if (scrollParent.value instanceof Element) {
        scrollParent.value.scrollTop = savedScrollTop.value;
      } else {
        window.scrollTo(0, savedScrollTop.value);
      }
      // console.log("blogcardlist被激活了");
      // console.log("savedScrollTop: " + savedScrollTop.value);
    });

    // 路由离开前保存滚动位置
    onBeforeRouteLeave((to, from, next) => {
      savedScrollTop.value = scrollParent.value.scrollTop;
      // console.log("blogcardlist路由离开了");
      // console.log("savedScrollTop: " + savedScrollTop.value);
      next();
    });

    return { root };
  },
  mounted() {
    this.loading = true;
    getCityOption().then((res) => {
      if (res.code === 200) {
        this.cityOption = res.data;
      }
    });
    getTypeOption().then((res) => {
      if (res.code === 200) {
        for (let data of res.data) {
          this.typeOption.push(data);
        }
      }
    });
    getJobList().then((res) => {
      if (res.code === 200) {
        this.dataList = res.data;
        this.loading = false;
      } else {
        showNotify({ type: 'danger', message: '服务器繁忙，请稍后再试。', position: 'bottom' });
      }
    });
  },
  methods: {
    toHomePage() {
      this.$router.push('/HomePage');
      window.sessionStorage.setItem('back', '/JobList');
    },
    showJob(data) {
      this.$router.push({
        name: 'JobInfo',
        params: {
          jobId: data['jobId']
        },
      });
      window.sessionStorage.setItem('jobInfo', JSON.stringify(data));
    },
    handleSearch(city, typeId, keyword) {
      this.loading = true;
      let obj = null;
      if ((city === null || city === '') && typeId === null && (keyword === null || keyword === '')) {
        obj = null;
      } else {
        obj = '';
        if (city != null && city !== '') {
          obj += ('city=' + city);
        }
        if (typeId != null) {
          if (obj === '') {
            obj += ('typeId=' + typeId);
          } else {
            obj += ('&typeId=' + typeId);
          }
        }
        if (keyword != null && keyword !== '') {
          if (obj === '') {
            obj += ('keyword=' + keyword);
          } else {
            obj += ('&keyword=' + keyword);
          }
        }
      }
      getJobList(obj).then((res) => {
        if (res.code === 200) {
          this.dataList = res.data;
          this.loading = false;
        } else {
          showNotify({ type: 'danger', message: '服务器繁忙，请稍后再试。', position: 'bottom' });
        }
      });
    }
  }
}
</script>

<style scoped>
.apply {
  width:100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.apply-top {
  background-color: rgb(248,248,248);
  padding-bottom: 10px;
}

.apply-body {
  flex: 1;
  overflow-y: scroll;
  padding-bottom: 20px;
}

/deep/ .van-hairline--bottom:after {
  border: none;
}

/deep/ .van-dropdown-menu__bar {
  box-shadow: none;
}

/deep/ .van-dropdown-menu__bar--opened {
  box-shadow: 0 2px 12px rgba(100, 101, 102, .12);
}

/deep/ .van-cell__title {
  min-width: 75%;
}

/deep/ .van-cell__value {
  min-width: 25%;
}

/deep/ .van-hairline--top-bottom:after {
  border: none;
}

/deep/ .van-swipe-cell:after {
  position: absolute;
  box-sizing: border-box;
  content: " ";
  pointer-events: none;
  right: var(--van-padding-md);
  bottom: 0;
  left: var(--van-padding-md);
  border-bottom: 1px solid var(--van-cell-border-color);
  transform: scaleY(.5);
}
</style>